import { Container } from '@chakra-ui/react';
import { Footer } from 'components';
import { Route, Switch, withRouter } from 'react-router-dom';
import { routes } from 'utils';
import { HowToPay } from './HowToPay';
import { PaymentDetails } from './PaymentDetails';
import { PaymentFailed } from './PaymentFailed';
import { PaymentMethod } from './PaymentMethod';
import { PaymentSuccessful } from './PaymentSuccessful';

const Booking = () => {

  return (
    <Container maxW='container.xl'>
        <Switch>
            <Route
                path={routes.BOOKING.HOW_TO_PAY}
                component={withRouter(HowToPay)}
            />
            <Route
              path={routes.BOOKING.PAYMENT_METHOD}
              component={withRouter(PaymentMethod)}
            />
            <Route
              path={routes.BOOKING.DETAILS}
              component={withRouter(PaymentDetails)}
            />
            <Route
              path={routes.BOOKING.PAYMENT_SUCCESSFUL}
              component={withRouter(PaymentSuccessful)}
            />
            <Route
              path={routes.BOOKING.PAYMENT_FAILED}
              component={withRouter(PaymentFailed)}
            />
      </Switch> 
      <Footer />
    </Container>
  );
};

export { Booking };
